export const OrderStatus = {
  PENDING:  "En attente",
  COMPLETE: "Terminé",
  CANCELED: "Annulé",
};

export const getOrderStatusOptions = () => {
  return [
    { value: "", label: "Tous les statuts" },
    ...Object.entries(OrderStatus).map(([key, label]) => ({
      value: key,
      label,
    })),
  ];
};